import { classNameType } from "@/types/generalTypes";
import React from "react";

function HamburgurMenu({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
    >
      <line
        x1="1.32195"
        y1="1.35676"
        x2="20.9127"
        y2="1.35676"
        stroke="#686868"
        strokeWidth="1.2064"
        strokeLinecap="round"
      />
      <line
        x1="1.32195"
        y1="7.68635"
        x2="20.9127"
        y2="7.68635"
        stroke="#686868"
        strokeWidth="1.2064"
        strokeLinecap="round"
      />
      <line
        x1="1.32195"
        y1="14.0159"
        x2="20.9127"
        y2="14.0159"
        stroke="#686868"
        strokeWidth="1.2064"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default HamburgurMenu;
